<template>
    <div class="menu" @mouseleave="hidden_sub_menu('xwzx')">
        <div class="more"><a href="http://kainamall.com/index.php" target="_blank"><i class="icon icon_shop1"></i>凯纳商城</a></div>
        <div class="center">
            <div class="logo" @click.stop="goTo('/')"><img src="../assets/img/logo.png" alt="LOGO" /></div>
            <div class="link">
                <span @mousemove="show_sub_menu('home');"><a href="/" class="t">首页</a></span>
                <span>
                    <a class="t" @mousemove="show_sub_menu('gykn');" @click.stop="goTo('GongSiJianJie')">关于凯纳</a>
                    <ul id="gykn" @mouseleave="hidden_sub_menu('gykn')" class="sub_menu_hidden">
                        <li><a @click.stop="goTo('GongSiJianJie')" :class="[menu_select == 'GongSiJianJie'?'now':'' ]">公司简介</a></li>
                        <li><a @click.stop="goTo('ZiZhiRongYu')" :class="[menu_select == 'ZiZhiRongYu'?'now':'' ]">企业荣誉</a></li>
                        <li><a @click.stop="goTo('GongSiZiZhi')" :class="[menu_select == 'GongSiZiZhi'?'now':'' ]">公司资质</a></li>
                        <li><a @click.stop="goTo('SheHuiZeRen')" :class="[menu_select == 'SheHuiZeRen'?'now':'' ]">社会责任</a></li>
                        <li><a @click.stop="goTo('YuanGongFengCai')" :class="[menu_select == 'YuanGongFengCai'?'now':'' ]">员工风采</a></li>
                        <li><a @click.stop="goTo('QiYeHuaCe')" :class="[menu_select == 'QiYeHuaCe'?'now':'' ]">企业画册</a></li>
                        <li><a @click.stop="goTo('QiYeXuanChuanPian')" :class="[menu_select == 'QiYeXuanChuanPian'?'now':'' ]">企业宣传片</a></li>
                    </ul>
                </span>
                <span>
                    <a class="t" @mousemove="show_sub_menu('xwzx');" @click.stop="goTo('QiYeDongTai')">新闻中心</a>
                    <ul id="xwzx" @mouseleave="hidden_sub_menu('xwzx')" class="sub_menu_hidden">
                        <li><a @click.stop="goTo('QiYeDongTai')" :class="[menu_select == 'QiYeDongTai'?'now':'' ]">企业动态</a></li>
                        <li><a @click.stop="goTo('MeiTiKanKaiNa')" :class="[menu_select == 'MeiTiKanKaiNa'?'now':'' ]">媒体看凯纳</a></li>
                        <li><a @click.stop="goTo('HangYeXinWen')" :class="[menu_select == 'HangYeXinWen'?'now':'' ]">行业新闻</a></li>
                        <li><a @click.stop="goTo('TongZhiGongGao')" :class="[menu_select == 'TongZhiGongGao'?'now':'' ]">通知公告</a></li>
                    </ul>
                </span>
                <span>
                    <a class="t" @mousemove="show_sub_menu('cgal');">典型案例</a>
                    <ul id="cgal" @mouseleave="hidden_sub_menu('cgal')" class="sub_menu_hidden">
                        <li><a @click.stop="goTo('ChengGongAnLi1')" :class="[menu_select == 'ChengGongAnLi1'?'now':'' ]">水务项目案例</a></li>
                        <li><a @click.stop="goTo('ChengGongAnLi2')" :class="[menu_select == 'ChengGongAnLi2'?'now':'' ]">环保项目案例</a></li>
                    </ul>
                </span>
                <span>
                    <a class="t" @mousemove="show_sub_menu('jjfa');" @click.stop="goTo('ZhiHuiGongShui')">解决方案</a>
                    <ul id="jjfa" @mouseleave="hidden_sub_menu('jjfa')" class="sub_menu_hidden">
                        <li><a @click.stop="goTo('ZhiHuiGongShui')" :class="[menu_select == 'ZhiHuiGongShui'?'now':'' ]">智慧供水</a></li>
                        <li><a @click.stop="goTo('ZhiHuiPaiShui')" :class="[menu_select == 'ZhiHuiPaiShui'?'now':'' ]">智慧排水</a></li>
                        <li><a @click.stop="goTo('NongCunShengHuoWuShuiZhiLi')" :class="[menu_select == 'NongCunShengHuoWuShuiZhiLi'?'now':'' ]">污水治理</a></li>
                        <li><a @click.stop="goTo('ZhiHuiChengShi')" :class="[menu_select == 'ZhiHuiChengShi'?'now':'' ]">智慧城市</a></li>
                        <li><a @click.stop="goTo('KaiNaShuiZhiFenXiYi')" :class="[menu_select == 'KaiNaShuiZhiFenXiYi'?'now':'' ]">水质分析仪</a></li>
                        <li><a @click.stop="goTo('ZhiHuiXinFang')" :class="[menu_select == 'ZhiHuiXinFang'?'now':'' ]">智慧信访</a></li>
                    </ul>
                </span>
                <!-- <span>
                    <a class="t" @mousemove="show_sub_menu('jszc');">技术支持</a>
                    <ul id="jszc" @mouseleave="hidden_sub_menu('jszc')" class="sub_menu_hidden">
                        <li><a @click.stop="goTo('ChanPinShuoMingShuXiaZai')">产品说明书下载</a></li>
                        <li><a @click.stop="goTo('YunWeiFuWu')">运维服务</a></li>
                        <li><a @click.stop="goTo('SheMiYeWuFuWu')">涉密业务服务</a></li>
                    </ul>
                </span>
                <span>
                    <a class="t" @mousemove="show_sub_menu('cpzx');" @click.stop="goTo('RuanJianChanPin')">产品中心</a>
                </span> -->
                <span>
                    <a class="t" @mousemove="show_sub_menu('cpzx');" @click.stop="goTo('RuanJianChanPin')">产品与服务</a>
                    <ul id="cpzx" @mouseleave="hidden_sub_menu('cpzx')" class="sub_menu_hidden">
                        <li><a @click.stop="goTo('RuanJianChanPin')" :class="[menu_select == 'RuanJianChanPin'?'now':'' ]">软件产品</a></li>
                        <li><a @click.stop="goTo('YingJianChanPin')" :class="[menu_select == 'YingJianChanPin'?'now':'' ]">硬件产品</a></li>
                        <!-- <li><a @click.stop="goTo('ZhiNengShuiBiao')" :class="[menu_select == 'ZhiNengShuiBiao'?'now':'' ]">智能水表</a></li> -->
                        <li><a @click.stop="goTo('CeShiPingTai')" :class="[menu_select == 'CeShiPingTai'?'now':'' ]">测试平台</a></li>
                        <li><a @click.stop="goTo('YunWeiFuWu')" :class="[menu_select == 'YunWeiFuWu'?'now':'' ]">运维服务</a></li>
                        <li><a @click.stop="goTo('SheMiYeWuFuWu')" :class="[menu_select == 'SheMiYeWuFuWu'?'now':'' ]">涉密业务服务</a></li>
                    </ul>
                </span>
                <span>
                    <a class="t" @mousemove="show_sub_menu('khylm');" @click.stop="goTo('WoMenDeKeHu')">客户与联盟</a>
                    <ul id="khylm" @mouseleave="hidden_sub_menu('khylm')" class="sub_menu_hidden">
                        <li><a @click.stop="goTo('WoMenDeKeHu')" :class="[menu_select == 'WoMenDeKeHu'?'now':'' ]">我们的客户</a></li>
                        <li><a @click.stop="goTo('HeZuoHuoBan')" :class="[menu_select == 'HeZuoHuoBan'?'now':'' ]">合作伙伴</a></li>
                        <li><a @click.stop="goTo('HeZuoJiGouYuGaoXiao')" :class="[menu_select == 'HeZuoJiGouYuGaoXiao'?'now':'' ]">合作机构与高校</a></li>
                        <!-- <li><a @click.stop="goTo('LianMengYuXieHui')">联盟与协会</a></li> -->
                        <li><a @click.stop="goTo('KeHuYuLianMengView1?id=14&customersType=604')" :class="[menu_select == 'KeHuYuLianMengView1?id=14&customersType=604'?'now':'' ]">联盟与协会</a></li>
                    </ul>
                </span>
                <span>
                    <a class="t" @mousemove="show_sub_menu('rczp');" @click.stop="goTo('SheHuiZhaoPin')">人才招聘</a>
                    <ul id="rczp" @mouseleave="hidden_sub_menu('rczp')" class="sub_menu_hidden">
                        <li><a @click.stop="goTo('SheHuiZhaoPin')" :class="[menu_select == 'SheHuiZhaoPin'?'now':'' ]">社会招聘</a></li>
                        <li><a @click.stop="goTo('XiaoYuanZhaoPin')" :class="[menu_select == 'XiaoYuanZhaoPin'?'now':'' ]">校园招聘</a></li>
                    </ul>
                </span>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            menu_select: '', //当前选中的菜单
        }; 
    },
    created() {},
    mounted() {},
    methods: {
        goTo(e) {
            //跳转页面
            this.$router.push(e);
            this.menu_select = e;
        },
        show_sub_menu( e ){
            console.log( "显示"+e );
            $(".link ul").removeClass().addClass("sub_menu_hidden");
            $("#"+e).removeClass("sub_menu_hidden").addClass("sub_menu_show");
        },
        hidden_sub_menu( e ){
            console.log( "隐藏"+e );
            $(".menu .center .link span ul").removeClass("sub_menu_show").addClass("sub_menu_hidden");
            //$("#"+e).removeClass("sub_menu_show").addClass("sub_menu_hidden");
        },
        // show_sub_menu( e ){
        //     console.log( e );
        //     if( e == 'home' ){
        //         $(".sub_menu .center span").removeClass("s_link link_show").addClass("link_hidden s_link");
        //     }else{
        //         $(".sub_menu .center span").removeClass("s_link link_show").addClass(" link_hidden s_link");
        //         $("#"+e).removeClass("s_link link_hidden").addClass("s_link link_show");
        //     };
        // },
        // hidden_sub_menu(){
        //     $(".sub_menu .center span").removeClass("s_link link_show").addClass("link_hidden s_link");
        // },
    },
};
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/PageHeader.vue